module.exports = __webpack_public_path__ + "img/RotatingNormal.f36a05ed.svg";